import { DoorsFormState } from "shared/utils/fieldsHelper/companyFields";
import React from "react";
import { formatTime } from "utilities";

interface Props {
  doors: DoorsFormState
}

const Doors = ({ doors }: Props) => {
  return <table className="s1_table clean">
    <tbody>
      {doors.open && <tr>
        <td>{RESX.Venue.Open}</td>
        <td>{formatTime(doors.open)}</td>
      </tr>}

      {doors.close && <tr>
        <td>{RESX.Venue.Close}</td>
        <td>{formatTime(doors.close)}</td>
      </tr>}
    </tbody>
  </table>;
};

export default Doors;
